import { Delete } from '@mui/icons-material';
import { Box, Button, CircularProgress, alpha, useTheme } from '@mui/material';
import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';

type PropsType = {
  src: string | null;
  loading: boolean;
  onDelete: () => void;
};

export const CoverArt = ({ src, loading, onDelete }: PropsType) => {
  const theme = useTheme();
  const { t } = useTranslation();

  const [isImageLoaded, setIsImageLoaded] = useState(false);

  const isLoading = loading || !isImageLoaded;

  const handleImageLoaded = useCallback(() => {
    setIsImageLoaded(true);
    if (!src) {
      return;
    }
    URL.revokeObjectURL(src);
  }, [src]);

  return (
    <Box
      sx={{
        height: theme.spacing(45),
        width: theme.spacing(45),
        position: 'relative',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        background: theme.palette.grey[700],
      }}
    >
      <CircularProgress
        sx={{
          display: isLoading ? 'block' : 'none',
        }}
      />
      {src && (
        <img
          alt="Cover Art"
          src={src}
          style={{
            display: isLoading ? 'none' : 'block',
            width: '100%',
            height: '100%',
          }}
          onLoad={handleImageLoaded}
        />
      )}
      {!isLoading && (
        <Button
          sx={{
            position: 'absolute',
            textTransform: 'none',
            bottom: theme.spacing(2),
            right: theme.spacing(2),
            borderRadius: theme.spacing(0.5),
            color: theme.palette.common.white,
            background: alpha(theme.palette.common.black, 0.5),
            '&:hover': {
              background: alpha(theme.palette.common.black, 0.75),
            },
          }}
          startIcon={<Delete />}
          onClick={onDelete}
        >
          {t('general:action:remove')}
        </Button>
      )}
    </Box>
  );
};
